import { render, staticRenderFns } from "./VLatestBlogs.vue?vue&type=template&id=697cf91d"
import script from "./VLatestBlogs.vue?vue&type=script&lang=js"
export * from "./VLatestBlogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports